import React from "react";


const BannerSection = ({Banner , title, subtitle}) => {
  return (
    <div>
      <div
        className="inner-header bg-holder"
        style={{backgroundImage: `url(${Banner})`}}
      >
        <div className="container">
          <div className="row  justify-content-center">
            <div className="col-md-12 text-center">
              <h1 className="title">{title}</h1>
              <p>{subtitle}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerSection;
